import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminLiveEventsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('live-event');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
